<template>
  <div class="page-sponsors" v-scroll-spy="scrollPos">

    <top-subpage-section>
      <page-header title="Sponsors">
        <div class="columns is-gapless is-vcentered is-flex-mobile has-text-centered" :class="[{ 'is-centered': !isDesktop }]">
          <div class="column" v-if="isDesktop">&nbsp;<!-- stub --></div>
          <div v-for="subnav in subnavs" key="subnav.title" class="column is-narrow subnav-item">
            <a :href="subnav.section ? ($route.name + '?anchor=' + subnav.section) : subnav.route" @click="$event.preventDefault();onScrollTo(subnav.route, subnav.section)">
              <img src="../assets/ic_info.svg" width=80 style="width:80px;" /><br />
              <h4 class="text">
                {{ subnav.title }}
              </h4>
            </a>
          </div>
        </div>
      </page-header>
    </top-subpage-section>

    <div class="page-content-bg">

      <div class="sponsors-official">
        <page-subheader title="Official Partners" :text-align="'center'" :title-style="{ borderBottom: '0px' }"></page-subheader>
        <div class="columns is-gapless is-centered is-vcentered is-flex-mobile is-multiline">
          <div v-for="mname in mnames" :key="mname" v-if="mitems[mname]" class="column is-3 is-6-mobile has-text-centered item-wrapper">
            <a v-if="mitems[mname].link" class="item" :href="mitems[mname].link" target="_blank">
              <img :src="mitems[mname].image.path" class="img-responsive" style="width:100%;max-width:160px;" nopin="nopin" />
            </a>
            <a v-else class="item" :href="'/about?anchor=' + mname">
              <img :src="mitems[mname].image.path" class="img-responsive" style="width:100%;max-width:160px;" nopin="nopin" />
            </a>
          </div>
        </div>
      </div>

      <sponsors-sub-section id="sponsors-level-1" title="J.D. Hogg Sponsors" level="1"></sponsors-sub-section>

      <sponsors-sub-section id="sponsors-level-2" title="The Duke Boys Sponsors" level="2"></sponsors-sub-section>

      <sponsors-sub-section id="sponsors-level-3" title="Uncle Jesse Sponsors" level="3"></sponsors-sub-section>

      <sponsors-sub-section id="sponsors-level-4" title="Roscoe P. Coltrane" level="4"></sponsors-sub-section>

      <sponsors-sub-section id="sponsors-level-5" title="Daisy Duke Sponsors" level="5"></sponsors-sub-section>

      <sponsors-sub-section id="sponsors-level-0" level="0" index="0" is-alt="true" is-limit-content="true"></sponsors-sub-section>

      <sponsors-sub-section id="sponsors-level-0" level="0" index="1" is-alt="false"></sponsors-sub-section>

    </div>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
import Site from '@/apis/Site'
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import PageHeader from '@/components/PageHeader'
import PageSubheader from '@/components/PageSubheader'
import TopSubpageSection from '@/components/TopSubpageSection'
import SponsorsSubSection from './SponsorsSubSection'

export default {
  name: 'sponsors',
  components: {
    DivContainer,
    PageHeader,
    PageSubheader,
    TopSubpageSection,
    SponsorsSubSection
  },
  data () {
    return {
      subnavs: [{
        route: 'sponsors',
        title: 'Info',
        section: 'sponsors-level-0'
      }],
      // subnavs: [{
      //   route: 'about',
      //   title: 'Official Partners'
      // }, {
      //   route: 'sponsors',
      //   title: 'Sponsors',
      //   section: 'sponsors-level-1'
      // }, {
      //   route: 'sponsors',
      //   title: 'Sponsorship',
      //   section: 'sponsors-level-0'
      // }],
      mnames: ['about-partner-1', 'about-partner-2', 'about-partner-3'],
      mitems: {},
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 1000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.refresh()
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },

    getMainItem: function (mname, onComplete) {
      this.loading = true
      this.error = undefined
      Site.aboutWithName('bosshog::' + mname)
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }

        if (onComplete) {
          onComplete(mname, data)
        }
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    refresh: function () {
      for (var i = 0; i < this.mnames.length; i++) {
        var mname = this.mnames[i]
        this.getMainItem(mname, (name, data) => {
          var params = {}
          if (data && data.image) {
            params.image = data.image
            params.link = data.link
          }
          this.$set(this.mitems, name, params)
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-sponsors {
  position: relative;

  .page-content-bg {
    // background-image: url(../assets/menubg.jpg);
    // background-repeat: no-repeat;
    // background-position: top;
  }

  .sponsors-official {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .item-wrapper {

    a.item {
      display: inline-block;
      position: relative;

      img {
        width: 100%;
        // opacity: 0.6;
        // filter: alpha(opacity=60);
        transition: all .2s ease-in-out;
      }

      &:hover {
        img {
          // opacity: 1.0;
          // filter: alpha(opacity=100);
          transform: scale(1.1);
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Sponsors.vue?457df0ea